import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { Section } from './Shared';
import { BodySilhouette, TreeOfLife } from './BioDecor';
const questions: string[] = ['¿Qué pregunto ahora?', '¿Cómo organizo toda esta información?', '¿Cómo profundizo sin perder el hilo?', '¿Qué recurso puedo utilizar para cerrar?', '¿Cómo hago seguimiento después de la sesión?'];
export function PainPoints() {
  return <Section className="max-w-5xl" data-id="element-317" data-mp="1xxhvtn8fgaf5">
      <div className="relative overflow-hidden rounded-3xl border border-brand-blue/25 bg-brand-blueMist/60 p-6 md:p-10" data-id="element-318" data-mp="1xwg8aja85vgj">
        <BodySilhouette className="pointer-events-none absolute -right-4 -top-6 h-56 w-28 text-brand-blue/15" data-id="element-319" data-mp="21x07rti9tb5u" />
        <div className="relative" data-id="element-320" data-mp="1syn0xmx6qveo">
          <h2 className="mb-5 text-center font-display text-2xl font-bold text-brand-blue md:text-4xl" data-id="element-321" data-mp="1szptdza5p5wp">
            Saber Biodescodificación no siempre significa saber qué hacer en cada momento de una sesión.
          </h2>
          <p className="mx-auto mb-8 max-w-2xl text-center text-base leading-relaxed text-brand-textLight md:text-lg" data-id="element-322" data-mp="3nbwi80vz3l7h">
            Tal vez conoces la teoría. Pero cuando tienes al consultante frente a ti aparecen otras preguntas:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-323" data-mp="27sqp6eh1mpla">
            {questions.map(question => <li key={question} className="rounded-xl border-l-4 border-brand-blueMid bg-white p-5" data-id="element-324" data-mp="27utgr2xugqs4">
                <p className="flex items-start gap-2 text-sm font-bold text-brand-blue md:text-base" data-id="element-325" data-mp="1g1szlj9z3l41">
                  <HelpCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-goldDark" data-id="element-326" data-mp="1b2pujytztew2" />
                  {question}
                </p>
              </li>)}
          </ul>
          <p className="mx-auto mt-8 max-w-3xl text-center text-sm leading-relaxed text-brand-textLight md:text-base" data-id="element-327" data-mp="1p3sea4ximd3t">
            Y cuando cada consulta depende de buscar apuntes, recordar de memoria o improvisar sobre la marcha,
            trabajar se vuelve mucho más difícil de lo necesario.
          </p>
        </div>
      </div>

      <div className="relative mt-12 overflow-hidden rounded-3xl border border-brand-gold/40 bg-brand-parchment p-8 text-center md:p-12" data-id="element-328" data-mp="1t5f0bv5z531n">
        <TreeOfLife className="pointer-events-none absolute -bottom-10 -left-6 h-48 w-28 text-brand-greenSoft/20" data-id="element-329" data-mp="1y2wzitu6w3wg" />
        <div className="relative" data-id="element-330" data-mp="226mmxfz4offw">
          <h3 className="font-display text-2xl font-bold leading-tight text-brand-blue md:text-4xl" data-id="element-331" data-mp="274o6e20gugrw">
            El problema no siempre es falta de conocimiento. Muchas veces es falta de{' '}
            <span className="text-brand-goldDark" data-id="element-332" data-mp="1eg8uvpgjmglb">SISTEMA</span>.
          </h3>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-brand-textLight md:text-lg" data-id="element-333" data-mp="1ee677c2v4zjr">
            Por eso creamos el Kit Maestro de Biodescodificación™: un sistema práctico para dejar de tener
            información dispersa y comenzar a trabajar con recursos organizados.
          </p>
        </div>
      </div>
    </Section>;
}